// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_1jFq5","title":"_3v6Ch"};